<template>
    <ul>
        <template
                v-for="menu in menus"
        >
            <router-link
                    tag="li"
                    active-class="active"
                    :to="link(menu)"
                    :key="menu.url"
                    exact
            >
                <a href="#">
                    <img v-if="!hideMenuImage && menu.iconUrl" :src="baseUrl+menu.iconUrl">
                    {{menu.title}}
                </a>
            </router-link>
        </template>
    </ul>
</template>

<script>

    export default {
        props: {
            menus: Array | Object,
            hideMenuImage: Boolean
        },
        data() {
            return {
                baseUrl: process.env.VUE_APP_BACK_URL
            }
        },
        methods: {
            link: function (menu) {
                switch (menu.view) {
                    case 'home':
                        return '/';
                    case 'page':
                        return '/article/' + menu.slug;
                    case 'indicators':
                        return '/indicators/' + menu.slug;
                    case 'page_blog':
                        return '/blog/' + menu.slug;
                    case 'ahchor':
                        return '#';
                    case 'url':
                        return '/' + menu.url;
                    default:
                        return '#';
                }
            }
        }
    }
</script>
